import { Helmet } from "react-helmet";
import { useState, useMemo } from "react";
import {
  FaMagnifyingGlass,
  FaChevronLeft,
  FaChevronRight,
  FaAnglesLeft,
  FaAnglesRight,
  FaFilter,
  FaBell,
  FaBellSlash,
  FaCircleCheck,
  FaCircleInfo,
  FaTriangleExclamation,
  FaCircleXmark,
  FaCheckDouble,
  FaEnvelopeOpen,
  FaEnvelope,
  FaClock,
} from "react-icons/fa6";
import { BtnDefault } from "../../../components/buttons/BtnDefault";
import { DashboardLayout } from "../../../components/layouts/DashboardLayout";
import { Header } from "../../../components/Header";

/* ============================================
   MOCK DATA NOTIFIKASI
   ============================================ */
const MOCK_NOTIFICATIONS = [
  { id: 1, type: "warning", title: "Stok Kritis: ONT ZTE F660", message: "Stok ONT ZTE F660 tersisa 3 unit, di bawah batas minimum 10 unit. Segera lakukan pengadaan.", read: false, created_at: "2025-06-17T14:30:00" },
  { id: 2, type: "error", title: "Stok Habis: Kabel Fiber Optic 12 Core", message: "Stok Kabel Fiber Optic 12 Core telah habis. Tidak dapat melakukan instalasi baru tanpa pengadaan.", read: false, created_at: "2025-06-17T13:15:00" },
  { id: 3, type: "info", title: "Pengadaan Diterima", message: "Pengadaan 50 unit Router Mikrotik hEX S (RB760iGS) telah diterima di gudang utama.", read: true, created_at: "2025-06-17T10:00:00" },
  { id: 4, type: "success", title: "Laporan Bulanan Tersedia", message: "Laporan monitoring barang bulan Mei 2025 telah berhasil digenerate dan siap diunduh.", read: true, created_at: "2025-06-16T16:45:00" },
  { id: 5, type: "warning", title: "Barang Rusak Terdeteksi", message: "Terdapat 5 unit TP-Link CPE210 terdeteksi rusak setelah pemeriksaan berkala. Perlu penanganan.", read: false, created_at: "2025-06-16T11:20:00" },
  { id: 6, type: "info", title: "Kategori Baru Ditambahkan", message: "Kategori baru 'Access Point Outdoor' telah ditambahkan ke sistem oleh Admin.", read: true, created_at: "2025-06-15T09:30:00" },
  { id: 7, type: "error", title: "Gagal Sinkronisasi Data", message: "Sinkronisasi data gudang cabang Bandung gagal. Periksa koneksi jaringan dan coba lagi.", read: false, created_at: "2025-06-15T08:00:00" },
  { id: 8, type: "success", title: "Data berhasil diimpor", message: "Impor data barang dari file Excel berhasil. 120 data baru telah ditambahkan ke sistem.", read: true, created_at: "2025-06-14T15:10:00" },
  { id: 9, type: "info", title: "Jadwal Maintenance Sistem", message: "Sistem akan mengalami maintenance pada 20 Juni 2025 pukul 00:00 - 03:00 WIB.", read: true, created_at: "2025-06-14T10:00:00" },
  { id: 10, type: "warning", title: "Stok Kritis: Konektor SC/APC", message: "Stok Konektor SC/APC tersisa 8 unit, mendekati batas minimum 10 unit.", read: false, created_at: "2025-06-13T17:30:00" },
  { id: 11, type: "info", title: "User Baru Terdaftar", message: "Akun baru dengan nama 'Budi Santoso' telah terdaftar sebagai Operator Gudang.", read: true, created_at: "2025-06-13T14:00:00" },
  { id: 12, type: "success", title: "Pengadaan Selesai Diproses", message: "Pengadaan PR-2025-0045 untuk 100 meter Kabel UTP Cat6 telah selesai diproses.", read: true, created_at: "2025-06-12T09:45:00" },
  { id: 13, type: "error", title: "Stok Habis: Tiang Besi 7 Meter", message: "Stok Tiang Besi 7 Meter telah habis. 3 tiket instalasi tertunda memerlukan barang ini.", read: false, created_at: "2025-06-12T07:30:00" },
  { id: 14, type: "warning", title: "Barang Mendekati Kadaluarsa", message: "Terdapat 2 unit SPLITER 1:8 yang mendekati masa garansi (sisa 14 hari).", read: true, created_at: "2025-06-11T16:00:00" },
  { id: 15, type: "info", title: "Update Sistem v2.4.1", message: "Sistem telah diperbarui ke versi 2.4.1. Fitur baru: export PDF laporan stok.", read: true, created_at: "2025-06-10T12:00:00" },
  { id: 16, type: "success", title: "Backup Data Berhasil", message: "Backup otomatis data sistem berhasil dilakukan. Ukuran: 245 MB.", read: true, created_at: "2025-06-10T03:00:00" },
  { id: 17, type: "warning", title: "Stok Kritis: Patch Cord 3 Meter", message: "Stok Patch Cord 3 Meter tersisa 5 unit, di bawah batas minimum 15 unit.", read: false, created_at: "2025-06-09T14:20:00" },
  { id: 18, type: "error", title: "Gagal Export Laporan", message: "Export laporan mingguan gagal karena data melebihi batas 10.000 baris. Gunakan filter.", read: true, created_at: "2025-06-09T10:15:00" },
];

/* ============================================
   HELPER: Format tanggal relatif
   ============================================ */
const formatRelativeTime = (dateStr) => {
  const now = new Date();
  const date = new Date(dateStr);
  const diffMs = now - date;
  const diffMin = Math.floor(diffMs / 60000);
  const diffHr = Math.floor(diffMs / 3600000);
  const diffDay = Math.floor(diffMs / 86400000);

  if (diffMin < 1) return "Baru saja";
  if (diffMin < 60) return `${diffMin} menit lalu`;
  if (diffHr < 24) return `${diffHr} jam lalu`;
  if (diffDay < 7) return `${diffDay} hari lalu`;
  return date.toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" });
};

const formatFullDate = (dateStr) => {
  return new Date(dateStr).toLocaleDateString("id-ID", {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const isToday = (dateStr) => {
  const d = new Date(dateStr);
  const now = new Date();
  return d.getDate() === now.getDate() && d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
};

/* ============================================
   KOMPONEN: Skeleton Bar
   ============================================ */
const SkeletonRow = ({ cols = 6 }) => (
  <tr className="animate-pulse">
    {Array.from({ length: cols }).map((_, i) => (
      <td key={i} className="px-4 py-3.5">
        <div
          className="h-3.5 bg-slate-700/60 rounded-md"
          style={{ width: `${30 + Math.random() * 60}%` }}
        />
      </td>
    ))}
  </tr>
);

const SkeletonCard = () => (
  <div
    className="rounded-2xl p-5 animate-pulse"
    style={{
      background: "rgba(15, 23, 42, 0.5)",
      border: "1px solid rgba(51, 65, 85, 0.3)",
    }}
  >
    <div className="flex items-start gap-3 mb-3">
      <div className="w-10 h-10 rounded-xl bg-slate-700/60 shrink-0" />
      <div className="flex-1 space-y-2">
        <div className="h-4 bg-slate-700/60 rounded-md w-3/4" />
        <div className="h-3 bg-slate-700/40 rounded-md w-full" />
        <div className="h-3 bg-slate-700/30 rounded-md w-1/2" />
      </div>
    </div>
    <div className="flex items-center justify-between pt-3" style={{ borderTop: "1px solid rgba(51, 65, 85, 0.15)" }}>
      <div className="h-3 bg-slate-700/30 rounded w-24" />
      <div className="h-5 bg-slate-700/40 rounded-full w-16" />
    </div>
  </div>
);

/* ============================================
   KOMPONEN: NotificationTypeBadge
   ============================================ */
const NotificationTypeConfig = {
  info: {
    icon: <FaCircleInfo size={14} />,
    label: "Info",
    bg: "rgba(59, 130, 246, 0.1)",
    border: "rgba(59, 130, 246, 0.2)",
    text: "#60a5fa",
    dotBg: "rgba(59, 130, 246, 0.3)",
    dotBorder: "rgba(59, 130, 246, 0.4)",
    rowHoverEnter: "rgba(59, 130, 246, 0.04)",
    cardBorderHover: "rgba(59, 130, 246, 0.2)",
    iconBg: "linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(59, 130, 246, 0.05))",
    iconBorder: "1px solid rgba(59, 130, 246, 0.15)",
    iconColor: "#60a5fa",
  },
  success: {
    icon: <FaCircleCheck size={14} />,
    label: "Berhasil",
    bg: "rgba(16, 185, 129, 0.1)",
    border: "rgba(16, 185, 129, 0.2)",
    text: "#34d399",
    dotBg: "rgba(16, 185, 129, 0.3)",
    dotBorder: "rgba(16, 185, 129, 0.4)",
    rowHoverEnter: "rgba(16, 185, 129, 0.04)",
    cardBorderHover: "rgba(16, 185, 129, 0.2)",
    iconBg: "linear-gradient(135deg, rgba(16, 185, 129, 0.15), rgba(16, 185, 129, 0.05))",
    iconBorder: "1px solid rgba(16, 185, 129, 0.15)",
    iconColor: "#34d399",
  },
  warning: {
    icon: <FaTriangleExclamation size={14} />,
    label: "Peringatan",
    bg: "rgba(245, 158, 11, 0.1)",
    border: "rgba(245, 158, 11, 0.2)",
    text: "#fbbf24",
    dotBg: "rgba(245, 158, 11, 0.3)",
    dotBorder: "rgba(245, 158, 11, 0.4)",
    rowHoverEnter: "rgba(245, 158, 11, 0.04)",
    cardBorderHover: "rgba(245, 158, 11, 0.2)",
    iconBg: "linear-gradient(135deg, rgba(245, 158, 11, 0.15), rgba(245, 158, 11, 0.05))",
    iconBorder: "1px solid rgba(245, 158, 11, 0.15)",
    iconColor: "#fbbf24",
  },
  error: {
    icon: <FaCircleXmark size={14} />,
    label: "Error",
    bg: "rgba(239, 68, 68, 0.1)",
    border: "rgba(239, 68, 68, 0.2)",
    text: "#f87171",
    dotBg: "rgba(239, 68, 68, 0.3)",
    dotBorder: "rgba(239, 68, 68, 0.4)",
    rowHoverEnter: "rgba(239, 68, 68, 0.04)",
    cardBorderHover: "rgba(239, 68, 68, 0.2)",
    iconBg: "linear-gradient(135deg, rgba(239, 68, 68, 0.15), rgba(239, 68, 68, 0.05))",
    iconBorder: "1px solid rgba(239, 68, 68, 0.15)",
    iconColor: "#f87171",
  },
};

const TypeBadge = ({ type }) => {
  const cfg = NotificationTypeConfig[type] || NotificationTypeConfig.info;
  return (
    <span
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold"
      style={{ background: cfg.bg, border: `1px solid ${cfg.border}`, color: cfg.text }}
    >
      {cfg.icon}
      {cfg.label}
    </span>
  );
};

const ReadBadge = ({ read }) => {
  if (read) {
    return (
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-slate-500/10 text-slate-400 border border-slate-500/20">
        <FaEnvelopeOpen size={10} />
        Dibaca
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold bg-cyan-500/10 text-cyan-400 border border-cyan-500/20">
      <FaEnvelope size={10} />
      Belum Dibaca
    </span>
  );
};

/* ============================================
   KOMPONEN: SummaryCard
   ============================================ */
const SummaryCard = ({ icon, label, value, accent = "cyan", pulse = false, solid = false }) => {
  const accents = {
    cyan: { bg: solid ? "bg-cyan-600" : "bg-cyan-500/10", border: solid ? "border-cyan-600" : "border-cyan-500/20", text: solid ? "text-white" : "text-cyan-400", icon: solid ? "text-cyan-200" : "text-cyan-500", sub: solid ? "text-cyan-100" : "text-slate-500" },
    blue: { bg: solid ? "bg-blue-600" : "bg-blue-500/10", border: solid ? "border-blue-600" : "border-blue-500/20", text: solid ? "text-white" : "text-blue-400", icon: solid ? "text-blue-200" : "text-blue-500", sub: solid ? "text-blue-100" : "text-slate-500" },
    amber: { bg: solid ? "bg-amber-600" : "bg-amber-500/10", border: solid ? "border-amber-600" : "border-amber-500/20", text: solid ? "text-white" : "text-amber-400", icon: solid ? "text-amber-200" : "text-amber-500", sub: solid ? "text-amber-100" : "text-slate-500" },
    orange: { bg: solid ? "bg-orange-600" : "bg-orange-500/10", border: solid ? "border-orange-600" : "border-orange-500/20", text: solid ? "text-white" : "text-orange-400", icon: solid ? "text-orange-200" : "text-orange-500", sub: solid ? "text-orange-100" : "text-slate-500" },
    red: { bg: solid ? "bg-red-600" : "bg-red-500/10", border: solid ? "border-red-600" : "border-red-500/20", text: solid ? "text-white" : "text-red-400", icon: solid ? "text-red-200" : "text-red-500", sub: solid ? "text-red-100" : "text-slate-500" },
    emerald: { bg: solid ? "bg-emerald-600" : "bg-emerald-500/10", border: solid ? "border-emerald-600" : "border-emerald-500/20", text: solid ? "text-white" : "text-emerald-400", icon: solid ? "text-emerald-200" : "text-emerald-500", sub: solid ? "text-emerald-100" : "text-slate-500" },
  };
  const a = accents[accent] || accents.cyan;

  return (
    <div className={`relative p-4 rounded-2xl border ${a.bg} ${a.border} ${pulse ? "animate-pulse" : ""}`}>
      <div className={`mb-2 ${a.icon}`}>{icon}</div>
      <p className={`text-2xl font-bold ${a.text}`}>{value.toLocaleString("id-ID")}</p>
      <p className={`text-xs font-medium mt-0.5 ${a.sub}`}>{label}</p>
    </div>
  );
};

/* ============================================
   KOMPONEN: Select Dark (inline)
   ============================================ */
const SelectDark = ({ value, onChange, options, placeholder }) => (
  <select
    value={value}
    onChange={(e) => onChange(e.target.value)}
    className="w-full px-3 py-2.5 text-sm rounded-xl bg-slate-800/60 border border-slate-600/40 text-gray-100 outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/20 transition-all appearance-none cursor-pointer"
    style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%2394a3b8' viewBox='0 0 16 16'%3E%3Cpath d='M8 11L3 6h10z'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 12px center",
    }}
  >
    {placeholder && <option value="">{placeholder}</option>}
    {options.map((opt) => (
      <option key={typeof opt === "string" ? opt : opt.value} value={typeof opt === "string" ? opt : opt.value}>
        {typeof opt === "string" ? opt : opt.label}
      </option>
    ))}
  </select>
);

/* ============================================
   KOMPONEN UTAMA: NotificationPage
   ============================================ */
export const NotificationPage = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState(MOCK_NOTIFICATIONS);

  // Filter & search state
  const [keyword, setKeyword] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [readFilter, setReadFilter] = useState("");
  const [page, setPage] = useState(1);
  const perPage = 8;

  // Simulasi loading awal
  useState(() => {
    setLoading(true);
    const t = setTimeout(() => setLoading(false), 800);
    return () => clearTimeout(t);
  });

  /* ---------- Stats ---------- */
  const stats = useMemo(() => {
    const total = notifications.length;
    const unread = notifications.filter((n) => !n.read).length;
    const readCount = total - unread;
    const today = notifications.filter((n) => isToday(n.created_at)).length;
    const byType = {
      info: notifications.filter((n) => n.type === "info").length,
      success: notifications.filter((n) => n.type === "success").length,
      warning: notifications.filter((n) => n.type === "warning").length,
      error: notifications.filter((n) => n.type === "error").length,
    };
    return { total, unread, read: readCount, today, byType };
  }, [notifications]);

  /* ---------- Filtered & Paginated Data ---------- */
  const filteredData = useMemo(() => {
    let result = [...notifications];

    if (keyword.trim()) {
      const kw = keyword.toLowerCase();
      result = result.filter(
        (n) =>
          n.title.toLowerCase().includes(kw) ||
          n.message.toLowerCase().includes(kw)
      );
    }
    if (typeFilter) {
      result = result.filter((n) => n.type === typeFilter);
    }
    if (readFilter === "unread") {
      result = result.filter((n) => !n.read);
    } else if (readFilter === "read") {
      result = result.filter((n) => n.read);
    }

    return result;
  }, [notifications, keyword, typeFilter, readFilter]);

  const totalPages = Math.max(1, Math.ceil(filteredData.length / perPage));
  const currentPage = Math.min(page, totalPages);
  const from = (currentPage - 1) * perPage;
  const to = Math.min(from + perPage, filteredData.length);
  const paginatedData = filteredData.slice(from, to);

  /* ---------- Handlers ---------- */
  const handleSearchChange = (val) => {
    setKeyword(val);
    setPage(1);
  };
  const handleTypeChange = (val) => {
    setTypeFilter(val);
    setPage(1);
  };
  const handleReadChange = (val) => {
    setReadFilter(val);
    setPage(1);
  };
  const handlePageChange = (p) => setPage(p);

  const resetFilter = () => {
    setKeyword("");
    setTypeFilter("");
    setReadFilter("");
    setPage(1);
  };

  const markAsRead = (id) => {
    setNotifications((prev) =>
      prev.map((n) => (n.id === id ? { ...n, read: true } : n))
    );
  };

  const markAllAsRead = () => {
    setNotifications((prev) => prev.map((n) => ({ ...n, read: true })));
  };

  /* ---------- Pagination Logic ---------- */
  const getPages = () => {
    const total = totalPages;
    const current = currentPage;
    const delta = 2;
    const pages = [];
    const left = Math.max(2, current - delta);
    const right = Math.min(total - 1, current + delta);
    pages.push(1);
    if (left > 2) pages.push("...");
    for (let i = left; i <= right; i++) pages.push(i);
    if (right < total - 1) pages.push("...");
    if (total > 1) pages.push(total);
    return pages;
  };

  /* ---------- Filter active count ---------- */
  const activeFilterCount = (typeFilter ? 1 : 0) + (readFilter ? 1 : 0);

  /* ---------- Column Config ---------- */
  const columns = [
    { key: "no", label: "No", align: "center", width: "55px" },
    { key: "type", label: "Tipe", align: "center", width: "130px" },
    { key: "title", label: "Judul", align: "left" },
    { key: "message", label: "Pesan", align: "left" },
    { key: "date", label: "Waktu", align: "left", width: "140px" },
    { key: "status", label: "Status", align: "center", width: "130px" },
  ];

  return (
    <>
      <Helmet>
        <title>Notifikasi - Radius Trend</title>
        <meta name="description" content="Pusat notifikasi sistem monitoring barang dan logistik." />
      </Helmet>

      <DashboardLayout showSidebar={showSidebar} setShowSidebar={setShowSidebar}>
        {/* ===== Header ===== */}
        <Header toggleSidebar={() => setShowSidebar(!showSidebar)}>
          <div className="flex items-center gap-3">
            <h2 className="text-base md:text-xl font-bold text-gray-100">
              Notifikasi
            </h2>
            {stats.unread > 0 && (
              <span className="hidden sm:inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-cyan-500/10 text-cyan-400 border border-cyan-500/20">
                {stats.unread} belum dibaca
              </span>
            )}
          </div>

          <div className="flex items-center gap-3">
            {stats.unread > 0 && (
              <BtnDefault onClick={markAllAsRead}>
                <span className="hidden lg:flex items-center gap-2">
                  <FaCheckDouble className="text-xs" />
                  Tandai Semua Dibaca
                </span>
                <FaCheckDouble className="lg:hidden" />
              </BtnDefault>
            )}
          </div>
        </Header>

        {/* ===== Content ===== */}
        <main className="p-4 lg:p-6 space-y-5">

          {/* ===== Summary Cards ===== */}
          <section className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4" aria-label="Ringkasan notifikasi">
            <SummaryCard icon={<FaBell size={20} />} label="Total Notifikasi" value={stats.total} accent="cyan" />
            <SummaryCard icon={<FaEnvelope size={20} />} label="Belum Dibaca" value={stats.unread} accent="blue" pulse={stats.unread > 0} />
            <SummaryCard icon={<FaEnvelopeOpen size={20} />} label="Dibaca" value={stats.read} accent="emerald" />
            <SummaryCard icon={<FaClock size={20} />} label="Hari Ini" value={stats.today} accent="amber" />
            <SummaryCard icon={<FaTriangleExclamation size={20} />} label="Peringatan" value={stats.byType.warning} accent="orange" pulse={stats.byType.warning > 0} />
            <SummaryCard icon={<FaCircleXmark size={20} />} label="Error" value={stats.byType.error} accent="red" solid pulse={stats.byType.error > 0} />
          </section>

          {/* ===== Unread Alert Banner ===== */}
          {stats.unread > 0 && (
            <div className="flex items-start gap-3 px-4 py-3.5 rounded-2xl bg-cyan-500/8 border border-cyan-500/20">
              <FaBell className="text-cyan-400 mt-0.5 shrink-0" size={16} />
              <div className="flex-1">
                <p className="text-sm font-bold text-cyan-300">
                  Anda memiliki {stats.unread} notifikasi yang belum dibaca
                </p>
                <p className="text-sm text-cyan-400/80 mt-0.5">
                  Klik pada notifikasi atau gunakan tombol "Tandai Semua Dibaca" untuk menandainya.
                </p>
              </div>
              <button
                onClick={markAllAsRead}
                className="shrink-0 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold text-cyan-300 bg-cyan-500/10 border border-cyan-500/20 hover:bg-cyan-500/20 transition-all"
              >
                <FaCheckDouble size={10} />
                Baca Semua
              </button>
            </div>
          )}

          {/* ===== Search & Filter ===== */}
          <section
            className="rounded-2xl p-4 sm:p-5"
            style={{
              background: "rgba(15, 23, 42, 0.5)",
              border: "1px solid rgba(51, 65, 85, 0.3)",
              backdropFilter: "blur(12px)",
            }}
            aria-label="Filter dan pencarian"
          >
            <div className="flex flex-col lg:flex-row lg:items-end gap-4">
              {/* Search */}
              <div className="w-full lg:max-w-xs flex-shrink-0">
                <label htmlFor="search-notif" className="block text-xs font-semibold text-slate-400 mb-1.5 uppercase tracking-wider">
                  Cari Notifikasi
                </label>
                <div className="relative">
                  <FaMagnifyingGlass className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-500 text-sm" />
                  <input
                    id="search-notif"
                    type="text"
                    placeholder="Judul, pesan..."
                    value={keyword}
                    onChange={(e) => handleSearchChange(e.target.value)}
                    className="w-full pl-10 pr-4 py-2.5 text-sm rounded-xl bg-slate-800/60 border border-slate-600/40 text-gray-100 placeholder-slate-500 outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/20 transition-all"
                  />
                </div>
              </div>

              {/* Filters */}
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1.5">
                  <FaFilter className="text-xs text-slate-500" />
                  <span className="text-xs font-semibold text-slate-400 uppercase tracking-wider">Filter</span>
                  {activeFilterCount > 0 && (
                    <span className="min-w-[18px] h-[18px] flex items-center justify-center bg-cyan-600 text-white text-[10px] font-bold rounded-full">
                      {activeFilterCount}
                    </span>
                  )}
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                  <SelectDark
                    value={typeFilter}
                    onChange={handleTypeChange}
                    options={[
                      { value: "info", label: "Info" },
                      { value: "success", label: "Berhasil" },
                      { value: "warning", label: "Peringatan" },
                      { value: "error", label: "Error" },
                    ]}
                    placeholder="Semua Tipe"
                  />
                  <SelectDark
                    value={readFilter}
                    onChange={handleReadChange}
                    options={[
                      { value: "unread", label: "Belum Dibaca" },
                      { value: "read", label: "Dibaca" },
                    ]}
                    placeholder="Semua Status"
                  />
                  <button
                    onClick={resetFilter}
                    className="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium text-slate-400 border border-slate-600/40 bg-slate-800/60 hover:text-slate-200 hover:border-slate-500/50 transition-all"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* ===== Desktop Table ===== */}
          <section
            className="hidden lg:block rounded-2xl overflow-hidden"
            style={{
              background: "rgba(15, 23, 42, 0.5)",
              border: "1px solid rgba(51, 65, 85, 0.3)",
              backdropFilter: "blur(12px)",
            }}
            aria-label="Tabel notifikasi"
          >
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                {/* Head */}
                <thead>
                  <tr
                    className="border-b"
                    style={{ background: "rgba(15, 23, 42, 0.7)", borderColor: "rgba(51, 65, 85, 0.3)" }}
                  >
                    {columns.map((col) => (
                      <th
                        key={col.key}
                        className={`px-4 py-3.5 text-xs font-semibold uppercase tracking-wider text-slate-400 ${col.align === "center" ? "text-center" : "text-left"}`}
                        style={col.width ? { width: col.width } : undefined}
                      >
                        {col.label}
                      </th>
                    ))}
                  </tr>
                </thead>

                {/* Body */}
                <tbody className="divide-y" style={{ borderColor: "rgba(51, 65, 85, 0.15)" }}>
                  {/* Loading */}
                  {loading && (
                    <>{[...Array(5)].map((_, i) => <SkeletonRow key={i} cols={columns.length} />)}</>
                  )}

                  {/* Empty */}
                  {!loading && paginatedData.length === 0 && (
                    <tr>
                      <td colSpan={columns.length} className="px-4 py-16 text-center">
                        <div className="flex flex-col items-center gap-3">
                          <div
                            className="w-16 h-16 rounded-2xl flex items-center justify-center"
                            style={{ background: "rgba(51, 65, 85, 0.2)", border: "1px solid rgba(51, 65, 85, 0.2)" }}
                          >
                            <FaBellSlash className="text-2xl text-slate-600" />
                          </div>
                          <div>
                            <p className="text-slate-400 font-medium">Tidak ada notifikasi ditemukan</p>
                            <p className="text-xs text-slate-500 mt-1">
                              {keyword || typeFilter || readFilter
                                ? "Coba ubah filter atau kata kunci pencarian"
                                : "Belum ada notifikasi"}
                            </p>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}

                  {/* Data Rows */}
                  {!loading &&
                    paginatedData.map((item, index) => {
                      const cfg = NotificationTypeConfig[item.type] || NotificationTypeConfig.info;
                      return (
                        <tr
                          key={item.id}
                          className="transition-colors duration-150 cursor-pointer"
                          style={{
                            background: item.read ? "transparent" : "rgba(0, 180, 216, 0.025)",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = cfg.rowHoverEnter;
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = item.read ? "transparent" : "rgba(0, 180, 216, 0.025)";
                          }}
                          onClick={() => markAsRead(item.id)}
                        >
                          {/* Unread dot + No */}
                          <td className="px-4 py-3 text-center">
                            <div className="flex items-center justify-center gap-2">
                              {!item.read && (
                                <span className="w-2 h-2 rounded-full bg-cyan-400 shrink-0 shadow-sm shadow-cyan-400/50" />
                              )}
                              <span className="text-slate-500 font-mono text-xs">
                                {item.read ? from + index + 1 : ""}
                              </span>
                            </div>
                          </td>

                          {/* Type */}
                          <td className="px-4 py-3 text-center">
                            <TypeBadge type={item.type} />
                          </td>

                          {/* Title */}
                          <td className="px-4 py-3">
                            <span className={`font-semibold text-sm ${item.read ? "text-slate-300" : "text-gray-100"}`}>
                              {item.title}
                            </span>
                          </td>

                          {/* Message */}
                          <td className="px-4 py-3">
                            <p className="text-xs text-slate-400 line-clamp-2 max-w-xs leading-relaxed">
                              {item.message}
                            </p>
                          </td>

                          {/* Date */}
                          <td className="px-4 py-3">
                            <span className="text-xs text-slate-400" title={formatFullDate(item.created_at)}>
                              {formatRelativeTime(item.created_at)}
                            </span>
                          </td>

                          {/* Status */}
                          <td className="px-4 py-3 text-center">
                            <ReadBadge read={item.read} />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div
                className="flex items-center justify-between px-5 py-3.5"
                style={{ borderTop: "1px solid rgba(51, 65, 85, 0.2)" }}
              >
                <p className="text-xs text-slate-500">
                  Menampilkan{" "}
                  <span className="text-slate-300 font-medium">{from + 1}</span> sampai{" "}
                  <span className="text-slate-300 font-medium">{to}</span> dari{" "}
                  <span className="text-slate-300 font-medium">{filteredData.length}</span>
                </p>

                <nav className="flex items-center gap-1" aria-label="Navigasi halaman">
                  <button
                    onClick={() => handlePageChange(1)}
                    disabled={currentPage === 1}
                    className="p-2 rounded-lg text-slate-400 hover:text-cyan-400 hover:bg-slate-700/40 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
                    aria-label="Halaman pertama"
                  >
                    <FaAnglesLeft className="text-xs" />
                  </button>
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="p-2 rounded-lg text-slate-400 hover:text-cyan-400 hover:bg-slate-700/40 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
                    aria-label="Halaman sebelumnya"
                  >
                    <FaChevronLeft className="text-xs" />
                  </button>

                  {getPages().map((p, i) =>
                    p === "..." ? (
                      <span key={`dot-${i}`} className="px-2 text-slate-600 text-sm">
                        ···
                      </span>
                    ) : (
                      <button
                        key={p}
                        onClick={() => handlePageChange(p)}
                        className={`min-w-[34px] h-9 px-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                          currentPage === p
                            ? "bg-cyan-600 text-white shadow-lg shadow-cyan-600/25"
                            : "text-slate-400 hover:text-gray-100 hover:bg-slate-700/40"
                        }`}
                      >
                        {p}
                      </button>
                    )
                  )}

                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="p-2 rounded-lg text-slate-400 hover:text-cyan-400 hover:bg-slate-700/40 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
                    aria-label="Halaman berikutnya"
                  >
                    <FaChevronRight className="text-xs" />
                  </button>
                  <button
                    onClick={() => handlePageChange(totalPages)}
                    disabled={currentPage === totalPages}
                    className="p-2 rounded-lg text-slate-400 hover:text-cyan-400 hover:bg-slate-700/40 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
                    aria-label="Halaman terakhir"
                  >
                    <FaAnglesRight className="text-xs" />
                  </button>
                </nav>
              </div>
            )}
          </section>

          {/* ===== Mobile Card List ===== */}
          <section className="lg:hidden space-y-3" aria-label="Daftar notifikasi">
            {/* Loading */}
            {loading && (
              <>{[...Array(4)].map((_, i) => <SkeletonCard key={i} />)}</>
            )}

            {/* Empty */}
            {!loading && paginatedData.length === 0 && (
              <div
                className="rounded-2xl p-12 text-center"
                style={{ background: "rgba(15, 23, 42, 0.5)", border: "1px solid rgba(51, 65, 85, 0.3)" }}
              >
                <div
                  className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4"
                  style={{ background: "rgba(51, 65, 85, 0.2)", border: "1px solid rgba(51, 65, 85, 0.2)" }}
                >
                  <FaBellSlash className="text-2xl text-slate-600" />
                </div>
                <p className="text-slate-400 font-medium">Tidak ada notifikasi ditemukan</p>
                <p className="text-xs text-slate-500 mt-1">
                  {keyword || typeFilter || readFilter ? "Coba ubah filter pencarian" : "Belum ada notifikasi"}
                </p>
              </div>
            )}

            {/* Cards */}
            {!loading &&
              paginatedData.map((item) => {
                const cfg = NotificationTypeConfig[item.type] || NotificationTypeConfig.info;
                return (
                  <article
                    key={item.id}
                    className="rounded-2xl p-4 active:scale-[0.98] transition-all duration-200 cursor-pointer relative"
                    style={{
                      background: item.read ? "rgba(15, 23, 42, 0.5)" : "rgba(0, 180, 216, 0.025)",
                      border: item.read
                        ? "1px solid rgba(51, 65, 85, 0.3)"
                        : "1px solid rgba(0, 180, 216, 0.12)",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.borderColor = cfg.cardBorderHover;
                      e.currentTarget.style.background = "rgba(15, 23, 42, 0.7)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.borderColor = item.read
                        ? "1px solid rgba(51, 65, 85, 0.3)"
                        : "1px solid rgba(0, 180, 216, 0.12)";
                      e.currentTarget.style.background = item.read ? "rgba(15, 23, 42, 0.5)" : "rgba(0, 180, 216, 0.025)";
                    }}
                    onClick={() => markAsRead(item.id)}
                  >
                    {/* Unread dot indicator */}
                    {!item.read && (
                      <span
                        className="absolute top-4 right-4 w-2.5 h-2.5 rounded-full bg-cyan-400 shadow-sm shadow-cyan-400/50"
                      />
                    )}

                    {/* Top: Icon + Title + Type */}
                    <div className="flex items-start gap-3 mb-3 pr-6">
                      <div
                        className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0"
                        style={{
                          background: cfg.iconBg,
                          border: cfg.iconBorder,
                          color: cfg.iconColor,
                        }}
                      >
                        {cfg.icon}
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 flex-wrap mb-1">
                          <h3
                            className={`font-semibold leading-tight text-sm ${item.read ? "text-slate-300" : "text-gray-100"}`}
                          >
                            {item.title}
                          </h3>
                        </div>
                        <div className="mt-1">
                          <TypeBadge type={item.type} />
                        </div>
                      </div>
                    </div>

                    {/* Message */}
                    <p className="text-xs text-slate-400 leading-relaxed mb-3 line-clamp-2">
                      {item.message}
                    </p>

                    {/* Bottom: Date + Status */}
                    <div
                      className="flex items-center justify-between pt-3"
                      style={{ borderTop: "1px solid rgba(51, 65, 85, 0.15)" }}
                    >
                      <span
                        className="text-xs text-slate-500 flex items-center gap-1.5"
                        title={formatFullDate(item.created_at)}
                      >
                        <FaClock size={10} />
                        {formatRelativeTime(item.created_at)}
                      </span>
                      <ReadBadge read={item.read} />
                    </div>
                  </article>
                );
              })}

            {/* Mobile Pagination */}
            {totalPages > 1 && (
              <div
                className="flex items-center justify-between pt-3 pb-6 px-1"
                style={{ borderTop: "1px solid rgba(51, 65, 85, 0.15)" }}
              >
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium text-slate-300 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
                  style={{ background: "rgba(15, 23, 42, 0.5)", border: "1px solid rgba(51, 65, 85, 0.3)" }}
                >
                  <FaChevronLeft className="text-xs" />
                  Sebelumnya
                </button>

                <span className="text-sm font-medium text-slate-400">
                  <span className="text-cyan-400">{currentPage}</span>
                  <span className="text-slate-600 mx-1">/</span>
                  {totalPages}
                </span>

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium text-slate-300 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
                  style={{ background: "rgba(15, 23, 42, 0.5)", border: "1px solid rgba(51, 65, 85, 0.3)" }}
                >
                  Berikutnya
                  <FaChevronRight className="text-xs" />
                </button>
              </div>
            )}
          </section>

          {/* ===== Legend ===== */}
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 px-1">
            <span className="text-[10px] text-slate-500 font-semibold uppercase tracking-wider">Tipe:</span>
            {Object.entries(NotificationTypeConfig).map(([key, cfg]) => (
              <div key={key} className="flex items-center gap-1.5">
                <span
                  className="w-2.5 h-2.5 rounded-full"
                  style={{ background: cfg.dotBg, border: `1px solid ${cfg.dotBorder}` }}
                />
                <span className="text-xs text-slate-400">{cfg.label}</span>
              </div>
            ))}
            <span className="mx-1 text-slate-700">|</span>
            <div className="flex items-center gap-1.5">
              <span className="w-2.5 h-2.5 rounded-full bg-cyan-400 shadow-sm shadow-cyan-400/50" />
              <span className="text-xs text-slate-400">Belum Dibaca</span>
            </div>
            <div className="flex items-center gap-1.5">
              <span className="w-2.5 h-2.5 rounded-full bg-transparent border border-slate-600" />
              <span className="text-xs text-slate-400">Dibaca</span>
            </div>
          </div>

        </main>
      </DashboardLayout>
    </>
  );
};